<template>
    <div class="flex-wrap hidden lg:flex lg:gap-x-12">
        <slot />
    </div>
</template>
